/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'

 
export const getAllApplicationUsers = createAsyncThunk('application/users/getAllApplicationUsers', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.applicationUsers.getAllApplicationUsers()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getAppUserHistory = createAsyncThunk('application/users/getAppUserHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.applicationUsers.getAppUserHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getAllOrgsAppsUsersByOrgID = createAsyncThunk('application/users/getAllOrgsAppsUsersByOrgID', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.applicationUsers.getAllOrgsAppsUsersByOrgID(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
